import ScheduleListRow from './ScheduleListRow';
export default class Member extends ScheduleListRow {
	get projects() {
		return this.children;
	}

	constructor(params) {
		super(params);
		if (params.projects !== undefined)
			this.children = params.projects;
		if (params.tel !== undefined)
			this.tel = params.tel;

		this.item_type = ScheduleListRow.ITEM_TYPE.MEMBER;
	}
}
